import axios from 'axios'
// import {
//   MessageBox,
//   Message
// } from 'element-ui'
// import store from '@/store'
import { getToken, isEmulation } from '@/utils/auth'
import router from '@/router'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 180000 // request timeout //issue 658
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // }
})

service.timeoutrequest = 180000; //issue 658

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    const token = getToken()
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'Bearer ' + token
      if(isEmulation()) {
        config.headers['isEmulation'] = isEmulation()
      }
      // config.headers['x-query-debug'] = true
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {

    const res = response.headers['content-type'] == 'application/json' ? response.data : response

    // if (response.status !== 200) {
    //   // Message({
    //   //   message: res.message || 'error',
    //   //   type: 'error',
    //   //   duration: 5 * 1000
    //   // })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //   //   // to re-login
    //   //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //   //     confirmButtonText: 'Re-Login',
    //   //     cancelButtonText: 'Cancel',
    //   //     type: 'warning'
    //   //   }).then(() => {
    //   //     store.dispatch('user/resetToken').then(() => {
    //   //       location.reload()
    //   //     })
    //   //   })
    //   // }
    //   return Promise.reject(res.message || 'error')
    // } else {
    return res
    // }
  },
  error => {
    if (error.response.status === 401) { // Unauthorized
      store.dispatch('user/resetToken')
      if (router.query && router.query.redirect) {
        router.push(`/login?redirect=${router.query.redirect}`)
      } else {
        router.push('/login')
      }
    }
    console.log('err : ' + error.response.data.message) // for debug
    return Promise.reject(error)
  })

export default service
